import axios from "axios";

// Same-origin in production to avoid CORS with custom domains; env var in preview/dev.
const getBaseURL = () => {
  if (typeof window !== "undefined" && window.location.hostname !== "localhost") {
    return `${window.location.origin}/api`;
  }
  return process.env.REACT_APP_BACKEND_URL
    ? `${process.env.REACT_APP_BACKEND_URL}/api`
    : "/api";
};

// SECURITY:
//   - `withCredentials: true` so the browser sends the HttpOnly auth cookie
//     automatically. The JWT is never readable from JS code, mitigating XSS
//     token theft.
//   - We do NOT attach an Authorization header from localStorage anymore.
//     There is no client-side token storage at all.
const API = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default API;
